<ngx-spinner></ngx-spinner>
  <section class="container-table">
    <div class="header d-flex justify-content-between">
    <h3 class="d-block">Inquiry Details</h3>
    <button class="btn_secondary"  [routerLink]="['/content-manager/inquiries']">Back</button>
  </div>
    <div class="row">
      <div class="col-4">
        <span>First Name:</span>
        <p> {{singleInquiry.first_name}}</p>
      </div>
      <div class="col-4">
        <span>Last Name:</span>
        <p> {{singleInquiry.last_name}}</p>
      </div>
      <div class="col-4">
        <span>Email:</span>
        <p> {{singleInquiry.email}}</p>
      </div>
      <div class="col-4">
        <span>Phone:</span>
        <p> {{singleInquiry.phone}}</p>
      </div>
      <div class="col-4">
        <span>Message:</span>
        <p> {{singleInquiry.message}}</p>
      </div>
      <div class="col-4">
        <span>Link:</span>
        <p> {{singleInquiry.url}}</p>
      </div>
      <div class="col-4">
        <span>Request:</span>
        <p> {{singleInquiry.request}}</p>
      </div>
      <div class="col-4">
        <span>Project:</span>
        <p> {{singleInquiry.project}}</p>
      </div>


      </div>
</section>

